import { Component, OnInit } from '@angular/core';
import { AmplitudeService } from '../shared/services/amplitude.service';

@Component({
  selector: 'cc-mobile-app',
  templateUrl: './mobile-app.component.html',
  styleUrls: ['./mobile-app.component.scss']
})
export class MobileAppComponent implements OnInit {
  constructor(private amplitudeService: AmplitudeService) {}

  ngOnInit() {
    this.amplitudeService.logEvent('Panel:Mobile:Init');
  }
}
